import { render, staticRenderFns } from "./RecentInspections.vue?vue&type=template&id=32680da5&"
import script from "./RecentInspections.vue?vue&type=script&lang=js&"
export * from "./RecentInspections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports